import(/* webpackMode: "eager" */ "/vercel/path0/apps/customer/public/assets/coming-soon.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/customer/public/delorand-white.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/customer/src/app/root-client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/customer/src/app/style/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/DMSans-VariableFont_opsz,wght.ttf\",\"variable\":\"--font-sans\"}],\"variableName\":\"sans\"}");
